import { createSlice } from '@reduxjs/toolkit';
import auth from '../../services/auth';

// Check if the stored token is expired
const isTokenExpired = (exp) => {
    if (!exp) return true;
    const currentTime = Math.floor(Date.now() / 1000);
    return currentTime > exp;
};

const loadState = () => {
    try {
        const serializedState = localStorage.getItem('auth');
        if (serializedState === null) {
            return {
                user: null,
                error: null,
                notification: null,
                exp: 0,
                iat: 0,
            };
        }
        const state = JSON.parse(serializedState);

        // Check if token is expired
        if (isTokenExpired(state.exp)) {
            localStorage.removeItem('auth');
            return {
                user: null,
                error: null,
                notification: null,
                exp: 0,
                iat: 0,
            };
        }

        return state;
    } catch (err) {
        return {
            user: null,
            error: null,
            notification: null,
            exp: 0,
            iat: 0,
        };
    }
};

const initialState = loadState();

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload?.user || null;
            state.exp = action.payload?.exp || 0;
            state.iat = action.payload?.iat || 0;
            // Save to localStorage
            localStorage.setItem('auth', JSON.stringify(state));
        },
        setLoginError: (state, action) => {
            state.error = action.payload;
            state.notification = 'Login failed. Please check your credentials.';
        },
    },
});

// Action creators are generated for each case reducer function
export const { setUser, setLoginError } = authSlice.actions;

export const login = (email, password) => (dispatch) =>
    auth
        .login(email, password)
        .then((result) => {
            dispatch(setUser(result.data));
            return true;
        })
        .catch((error) => {
            dispatch(setLoginError(error));
            return false;
        });

export const logout = () => (dispatch) => {
    auth.logout().then((result) => {
        // Clear the auth state
        dispatch(setUser({ user: null, exp: 0, iat: 0 }));
        // Clear localStorage
        localStorage.removeItem('auth');
        // Navigate to login page
        // window.location.href = process.env.PUBLIC_URL + '/login';
        const basename = process.env.PUBLIC_URL || '';
        window.location.href = basename + '/login';
    });
};

export const selectUser = (state) => state.auth.user;

export default authSlice.reducer;
